import { render, staticRenderFns } from "./TemplateLoaderCourseSingle.vue?vue&type=template&id=5b6af389&scoped=true&"
import script from "./TemplateLoaderCourseSingle.vue?vue&type=script&lang=js&"
export * from "./TemplateLoaderCourseSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6af389",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFadeTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VFadeTransition})
